var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-title-params" },
    [
      _c("stars-rating", {
        staticClass: "info-title-params__rating",
        attrs: { value: _vm.rating }
      }),
      _c("ui-badge", { attrs: { text: _vm.counter, color: "#000" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }